/**
 * Order participants
 */
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider.state('order.participants', {
        url: '/' + urls.order.participants.fr, // TODO : when multilang, change this to something dynamic
        resolve: {
            participantsCondition: ['$q', 'profile', 'cart', function ($q, $profile, $cart) {
                var deferred = $q.defer();
                $profile.claim().then(function() {
                    // check if profile is authenticated & fullfiled
                    if ($profile.authorization.authenticated && $profile.info.field_nom) {
                        // check if address is fullfiled
                        if (!$profile.isFullfilled()) {
                            deferred.reject({ status: 'ORDER_LOGIN__MISSING_ADDRESS' });
                        }
                        // check if some internships are in cart
                        if ($cart.internships.length) {
                            // need to fullfiled participants information : display form
                            deferred.resolve();
                        } else  {
                            // prepare rerouting (see app.js)
                            deferred.reject({status: 'ORDER_PARTICIPANTS__NO_INTERNSHIP'});
                        }
                    } else {
                        // no user authenticated
                        deferred.reject({status: 'ORDER_LOGIN__NEEDED'});
                    }
                });
                return deferred.promise;
            }]
        },
        views: {
            content: {
                controller: ['$scope', '$rootScope', 'cart', '$state', '$filter', 'tools', 'profile', 'lodash', 'drupal', 'moment', '$document', '$location', 'formPattern', 'utils', function ($scope, $rootScope, $cart, $state, $filter, $tools, $profile, lodash, drupal, moment, $document, $location, formPattern, utils) {
                    $scope.loading = false;
                    $scope.formPattern = formPattern;
                    $scope.dateRegex = new RegExp("^(?:(?:31(\\/)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$");

                    $rootScope.titlePanel = {
                        title: $filter('translate')('order.participants'),
                        subtitle: ''
                    };
                    $scope.tools = $tools;

                    $scope.optionsCivility = [
                        { text: $filter('translate')('form.male'), value: 'M.' },
                        { text: $filter('translate')('form.female'), value: 'Mme' }
                    ];

                    $scope.membershipLabels = {
                        placeholder: $filter('translate')('cart.memberPlaceholder'),
                        info: $filter('translate')('cart.notMember')
                    };

                    $scope.cart = $cart;

                    $scope.user = $profile.info;

                    // Init form data
                    $scope.cart.internships.forEach(function(internship) {
                        drupal.getProductRelated(internship.field_internship.product.sfid, internship.id).then(function(products) {
                            internship.field_internship.field_guarantees = [];
                            internship.field_internship.field_options = [];

                            products.forEach(function(product) {
                                if (product.family === 'Assurance') {
                                    internship.field_internship.field_guarantees.push(product);
                                }
                                if (product.family === 'Location') {
                                    internship.field_internship.field_options.push(product);
                                }
                            });

                            var day = new Date(internship.field_internship.startDate);
                            internship.minAge = new Date(day.getFullYear() - internship.field_internship.product.maxAge, day.getMonth(), day.getDate());
                            internship.maxAge = new Date(day.getFullYear() - internship.field_internship.product.minAge, day.getMonth(), day.getDate());

                            if(angular.isUndefined(internship.participants) || internship.participants.length == 0) {
                                internship.participants = [];

                                $tools.getRange(1, internship.field_quantity).forEach(function() {
                                    internship.participants.push({
                                        needOtherContact: false,
                                        field_legal_guardian: {},
                                        field_other_contact: {},
                                        field_guarantees: angular.copy(internship.field_internship.field_guarantees),
                                        field_options: angular.copy(internship.field_internship.field_options)
                                    });
                                });
                            }
                            else {
                                if (internship.participants.length > internship.field_quantity) {
                                    internship.participants = lodash.slice(internship.participants, 0, internship.field_quantity);
                                }
                                if(internship.participants.length < internship.field_quantity){
                                    $tools.getRange(internship.participants.length, internship.field_quantity - 1).forEach(function() {
                                        internship.participants.push({
                                            needOtherContact: false,
                                            field_legal_guardian: {},
                                            field_other_contact: {},
                                            field_guarantees: angular.copy(internship.field_internship.field_guarantees),
                                            field_options: angular.copy(internship.field_internship.field_options)
                                        });
                                    });
                                }
                            }
                        });
                    });

                    // Updates participant with authenticated user
                    $scope.updateParticipant = function (participant, direction) {
                        for (var key in $scope.user) {
                            participant[key] = direction ? $scope.user[key] : null;
                        }
                        // remove legual guardian (secondary contact) if user is an adult
                        if (moment().diff(participant.field_date_de_naissance, 'years') >= 18) {
                            participant.needOtherContact = false;
                            participant.field_legal_guardian = {};
                            participant.field_other_contact = {};
                        }
                    };

                    $scope.scrolltoForm = function () {
                        var element = angular.element(document.getElementById('orderForm'));
                        $document.scrollToElement(element, 30, 250);
                    };

                    $scope.pay = function () {
                        if (!$scope.pending) {
                            if ($scope.participantsForm.$valid) {
                                // update cart : transform input date format (DD/MM/YYYY) to salesforce output (YYYY-MM-DD)
                                $scope.cart.internships.forEach(function (i) {
                                    i.participants.forEach(function (p) {
                                        // remove subform display flag from SF model
                                        delete p.needOtherContact;
                                        if (p.participantAuth) {
                                            delete p.field_nationality;
                                            delete p.field_mobile;
                                            delete p.field_phone;
                                            delete p.field_country;
                                            delete p.field_address;
                                            delete p.field_postal_code;
                                            delete p.field_city;
                                        }

                                        p.field_date_de_naissance = moment(p.field_date_de_naissance, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                                        if (p.field_legal_guardian && p.field_legal_guardian.field_date_de_naissance) {
                                            p.field_legal_guardian.field_date_de_naissance = moment(p.field_legal_guardian.field_date_de_naissance, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                                        }
                                        if (p.field_other_contact && p.field_other_contact.field_date_de_naissance) {
                                            p.field_other_contact.field_date_de_naissance = moment(p.field_other_contact.field_date_de_naissance, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                                        }
                                    });
                                });
                                $scope.cart.save();
                                $scope.pending = true;
                                $state.go('order.payment');
                            } else  {
                                $location.hash('form');
                                $scope.scrolltoForm();
                            }
                        }
                    };
                    utils.calendarTrad()
                    $scope.initDatepicker = function(){
                        utils.calendarTrad()
                    }
                }],
                templateUrl: 'src/views/order/order_participants.html'
            }
        }
    });
}]);
